// extracted by mini-css-extract-plugin
export var content = "_ma-1";
export var divider = "_ma-0";